<template>
  <div>
    <modal
      :exibir="exibir"
      @fechar="fecharModal"
      :titulo="`Contatos de ${pessoaSelecionada.nome}`"
      :campos="$refs"
      id="modalVinculosContatos"
      tamanho="lg"
      ocultarRodape
    >
      <div v-if="!exibirForm">
        <div>
          <div v-if="!modoVisualizacao">
            <p>
              Ao editar os contatos de uma pessoa neste modal, é automaticamente
              atualizado os dados na ficha da pessoa escolhida, não sendo
              necessário ir até o perfil dela para editar.
            </p>
          </div>
          <b-table
            :empty-text="$t('GERAL.NENHUM_REGISTRO')"
            head-variant="light"
            :items="contatos"
            :fields="campos"
            show-empty
            responsive
            striped
            hover
          >
            <template #cell(acoes)="item">
              <div class="flex">
                <b-dropdown variant="outline-default" :disabled="modoVisualizacao">
                  <b-dropdown-item @click="excluirContato(item.item)">
                    {{ $t('GERAL.EXCLUIR') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="editar(item.item)">
                    {{ $t('GERAL.EDITAR') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
          <div class="d-flex space-between w-100 mt-4">
            <b-button variant="secondary" @click="fecharModal">{{
              $t('GERAL.FECHAR')
            }}</b-button>
            <b-button v-if="!modoVisualizacao" variant="primary" @click="abrirForm">
              Criar novo contato
            </b-button
            >
          </div>
        </div>
      </div>
      <div v-else>
        <vinculos-contatos-form
          :pessoaId="pessoaSelecionada.pessoaId"
          :contato="contatoSelecionado"
          @fechar="fecharForm"
          @atualizar="buscarPessoa()"
        />
      </div>
    </modal>
  </div>
</template>

<script>
//aux & helpers
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

//Services
import PessoaService from '@/common/services/pessoa/pessoa.service';

// components
import Modal from '@/components/modal/Modal.vue';
import VinculosContatosForm from '@/views/academico/matriculas/components/VinculosContatosForm.vue';

export default {
  components: {
    Modal,
    VinculosContatosForm,
  },
  computed: {
    modoVisualizacao() {
      return this.$route.path.includes('visualizar');
    }
  },
  props: {
    exibir: { type: Boolean, default: false },
    pessoaSelecionada: { type: Object, default: Object },
  },
  data() {
    return {
      campos: [
        {
          key: 'nome',
          label: 'Nome',
        },
        {
          key: 'descricao',
          label: 'Descrição',
        },
        {
          key: 'tipoContatoDescricao',
          label: 'Tipo de Contato',
        },
        {
          key: 'principal',
          label: 'Principal',
          formatter: (value) => {
            return value ? 'Sim' : 'Não';
          },
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      contatos: [],
      exibirForm: false,
      contatoSelecionado: null,
    };
  },
  methods: {
    buscarPessoa() {
      this.$store.dispatch(START_LOADING);
      PessoaService.buscarPorId(this.pessoaSelecionada.pessoaId)
        .then(({ data }) => {
          this.contatos = data.contatos;
        })
        .catch((erro) => {
          this.fecharModal();
          mensagem.showErrors(erro);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    async excluirContato(contato) {
      const respostaExclusao = await mensagem.confirmacao(
        null,
        this.$t('PESSOAS.CONFIRMAR_EXCLUIR_CONTATO')
      );
      if (respostaExclusao.isConfirmed) {
        PessoaService.removerContato(contato.id)
          .then(() => {
            mensagem.sucesso(
              this.$t('GERAL.SUCESSO'),
              this.$t('PESSOAS.CONTATO_EXCLUIDO')
            );
            this.buscarPessoa();
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    editar(contato) {
      this.contatoSelecionado = contato;
      this.abrirForm();
    },
    abrirForm() {
      this.exibirForm = true;
    },
    fecharForm() {
      this.contatoSelecionado = null;
      this.exibirForm = false;
    },
    fecharModal() {
      this.exibirForm = false;
      this.$emit('fechar');
    },
  },
  watch: {
    exibir(valor) {
      if (valor) {
        this.buscarPessoa();
      }
    },
  },
};
</script>
